import React from 'react';
import { FaEye, FaUsers, FaCalendarCheck, FaVideo, FaFilm } from 'react-icons/fa';

const ApplicationMobileCard = ({ item, handleViewApp }) => {
    const isSelected = String(item.status).toLowerCase() === 'selected';
    const isRejected = String(item.status).toLowerCase() === 'rejected';
    let statusClass = 'pmp-status-inactive';
    if (isSelected) statusClass = 'pmp-status-active';
    else if (isRejected) statusClass = 'pmp-status-expired';

    return (
        <div key={item.id} className="project-mobile-card mb-3">
            <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                    <h6 className="project-card-title m-0 text-white fw-bold">{item.candidateName}</h6>
                    <small className="text-warning fw-bold">{item.roleName}</small>
                </div>
                <span className={`pmp-status-tag ${statusClass}`}>
                    {item.status}
                </span>
            </div>

            <div className="card-data-grid mt-2 mb-2">
                <div className="data-item">
                    <FaUsers className="text-danger" />
                    <span className="lbl">Role:</span>
                    <span className="val text-truncate" style={{ maxWidth: '110px' }}>{item.roleName}</span>
                </div>
                <div className="data-item">
                    <FaFilm className="text-info" />
                    <span className="lbl">Project:</span>
                    <span className="val text-truncate" style={{ maxWidth: '110px' }}>{item.projectName}</span>
                </div>
                <div className="data-item">
                    <FaCalendarCheck className="text-success" />
                    <span className="lbl">Applied:</span>
                    <span className="val">{item.date !== 'N/A' ? item.date : 'Walk-in'}</span>
                </div>
                <div className="data-item">
                    <FaVideo className="text-warning" />
                    <span className="lbl">Mode:</span>
                    <span className="val text-truncate">{item.auditionType}</span>
                </div>
            </div>

            <hr className="compact-hr my-2" />

            <div className="d-flex justify-content-between align-items-center">
                <div className="house-data">
                    <span className="house-name-gold">Status: {item.verifyStatus || 'Verified'}</span>
                </div>
                <div className="pmp-action-btn-group d-flex gap-2">
                    <button 
                        type="button" 
                        className="pmp-btn-action pmp-btn-edit" 
                        onClick={() => handleViewApp(item.id)}
                        title="View Application Details"
                    >
                        <FaEye size={13} color="#ffffff" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApplicationMobileCard;
